import { applyDevCsp } from './devCsp';

/** Only the explicitly named isolated CI build may contact a loopback backend.
 * Ordinary production builds retain their exact policy. No browser CSP bypass.
 */
export function isolatedBuiltCsp(policy: string, mode: string, backend: string | undefined): string {
  if (mode !== 'e2e-built') return policy;
  let url: URL;
  try { url = new URL(backend ?? ''); } catch { throw new Error('Isolated built mode requires a loopback Supabase URL'); }
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password ||
      !['localhost', '127.0.0.1', '[::1]'].includes(url.hostname)) {
    throw new Error('Isolated built mode requires a loopback Supabase URL');
  }
  return applyDevCsp(`${policy};`, url.origin).replace(/;$/, '');
}
